var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDeselect(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "deselect icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Select/unselect-products",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.3_Select-and-unselect-products",
    transform: "translate(-779.000000, -249.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "products",
    transform: "translate(16.000000, 239.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image-hover",
    transform: "translate(754.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "product-bar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.203125,23.515625 C22.765625,23.515625 23.5625,22.7265625 23.5625,21.1796875 L23.5625,12.1640625 C23.5625,10.625 22.765625,9.8359375 21.203125,9.8359375 L12.2421875,9.8359375 C10.6796875,9.8359375 9.8828125,10.6171875 9.8828125,12.1640625 L9.8828125,21.1796875 C9.8828125,22.7265625 10.6796875,23.515625 12.2421875,23.515625 L21.203125,23.515625 Z M15.7265625,20.484375 C15.4609375,20.484375 15.2578125,20.3671875 15.046875,20.109375 L12.9140625,17.4921875 C12.796875,17.3515625 12.7265625,17.171875 12.7265625,17 C12.7265625,16.640625 13.015625,16.359375 13.359375,16.359375 C13.578125,16.359375 13.765625,16.4375 13.9375,16.671875 L15.6953125,18.921875 L19.09375,13.4765625 C19.2421875,13.234375 19.4453125,13.1171875 19.6484375,13.1171875 C19.9921875,13.1171875 20.3125,13.34375 20.3125,13.7109375 C20.3125,13.8828125 20.2265625,14.0625 20.125,14.21875 L16.3671875,20.1015625 C16.203125,20.359375 15.984375,20.484375 15.7265625,20.484375 Z",
    id: "deselect-icon"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeselect);
export default __webpack_public_path__ + "static/media/icon_deselect.10b4b903.svg";
export { ForwardRef as ReactComponent };